import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from './guards/admin.guard';

const routes: Routes = [
  {
    path: 'administration',
    canActivate: [AdminGuard],
    loadChildren: () =>
      import(
        `./components/bed-institut-wissen/administration/administration-routing.module`
      ).then(m => m.AdministrationRoutingModule),
  },
  {
    path: '',
    loadChildren: () =>
      import(`./components/institut-wissen-routing.module`).then(
        m => m.InstitutWissenRoutingModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
